import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setResetTab, updateData } from "../../../../newapi/global/progressionTabSlice";

import ProgressionModal from "../../../theme/ProgressionBuilder/ProgressionModal";
import ProgressionWrapper from "../../../theme/ProgressionBuilder/ProgressionWrapper";
import { useCreateOrderMutation } from "../../../../newapi/order/ordersSlice";
import Details from "./views/Details";
import AddressDetails from "./views/AddressDetails";
import Orderlines from "./views/Orderlines";

const MpDuplicateOrder = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const onSave = (response, openAfterSave) => {
        props.handleClose();
        // The create response is the new order itself, so the id is on response.id.
        const createdOrderId = response?.id;
        if (openAfterSave && createdOrderId) {
            props.onOpenCreatedOrder?.(createdOrderId);
        }
    };

    // Initialize the progression state with order data when modal opens
    useEffect(() => {
        if (props.open && props.orderData) {
            // Reset the progression state first
            dispatch(setResetTab());
            // Initialize with order data
            const initialData = {
                relationId: props.orderData.relationId || "",
                webshopreference: props.orderData.webshopreference ? `${props.orderData.webshopreference}-1` : "",
                plannedDate: props.orderData.date_planned || new Date().toISOString().split('T')[0],
                deliveryName: props.orderData.deliveryName || "",
                remark: props.orderData.remark || "",
                ...(props.orderData.deliveryMethod === "dropshipping" ? {deliveryMethod: props.orderData.deliveryMethod} : {}),
                isB2B: props.orderData.isB2B ? true : false,
                shippingAddress: {
                    firstName: props.orderData.shippingAddress?.firstName || "",
                    lastName: props.orderData.shippingAddress?.lastName || "",
                    address1: props.orderData.shippingAddress?.addressLine1 || "",
                    address2: props.orderData.shippingAddress?.addressLine2 || "",
                    postal: props.orderData.shippingAddress?.postalCode || "",
                    city: props.orderData.shippingAddress?.city || "",
                    country_code: props.orderData.shippingAddress?.country?.toLowerCase() || "",
                    email: props.orderData.shippingAddress?.email || "",
                    phone: props.orderData.shippingAddress?.phone || "",
                    company: props.orderData.shippingAddress?.company || ""
                },
                orderlines: props.orderData.orderlines?.filter(line => line.parentProductId === null && line.type !== "add_on").map(line => ({
                    sku: line.product?.sku,
                    amount: line.amount
                })) || []
            };
            
            dispatch(updateData(initialData));
        }
    }, [props.open, props.orderData, dispatch]);

    // Reset progression state when modal closes
    useEffect(() => {
        if (!props.open) {
            dispatch(setResetTab());
        }
    }, [props.open, dispatch]);

    return (
        <ProgressionModal
            open={props.open}
            onClose={props.handleClose}
        >
            <ProgressionWrapper 
                onSave={onSave} 
                query={useCreateOrderMutation} 
                isModal 
                title={t("duplicate_order")}
            >
                <Details/>
                <AddressDetails/>
                <Orderlines/>
            </ProgressionWrapper>
        </ProgressionModal>
    )
}

export default MpDuplicateOrder; 